import { createSelector } from '@reduxjs/toolkit';
import { HubPageTypes } from '../../constants';
import { siteTypesEnum } from '../../helpers';
import { getAdvertisingPageCategory } from './getAdvertisingPageCategory';
import { parseLandingRouteParams } from './parseLandingRouteParams';

const selectPageConfig = (state) => state.pageConfig;

const selectAudienceHubLandingPath = (state) => {
  const { AUDIENCE_HUB } = siteTypesEnum();
  const { siteType } = state.pageConfig || {};

  if (siteType !== AUDIENCE_HUB) {
    return '';
  }

  const page = state.audienceHUB?.page?.data;

  if (page?.pageType === HubPageTypes.Landing) {
    return page.landingPage?.details?.path || '';
  }

  return '';
};

export const selectAdvertisingPageCategory = createSelector(
  [selectPageConfig, selectAudienceHubLandingPath],
  (
    {
      siteSubPath = '',
      location: { pathname = '' } = {},
      singleSiteMode = false,
      brandSubPath,
      siteType,
      audienceType,
      isPreview = false,
      newPaymentJourneyEnabled,
    },
    audienceHubLandingPath,
  ) => {
    if (audienceHubLandingPath) {
      return getAdvertisingPageCategory({
        siteSubPath: audienceHubLandingPath,
      });
    }

    const { landingGroupPath, landingPath } = parseLandingRouteParams(
      pathname,
      {
        siteType,
        audienceType,
        isPreview,
        singleSiteMode,
        brandSubPath,
        newPaymentJourneyEnabled,
      },
    );

    return getAdvertisingPageCategory({
      siteSubPath,
      landingGroupPath,
      landingPath,
    });
  },
);
